export default {
    auth: {
        registration: {
            title: 'Come Chill with us',
            alreadyAMember: 'Already have an account? ',
            message: '',
            messagePublic:
                'Interested in bringing a little Chill to your team?',
            signIn: 'Sign in',
            confirm: 'Continue',
            successMessage: '',
            errorMessage: 'Invalid email address or password'
        },
        registrationHospital: {
            title: 'Mindfulness matters',
            message: 'Welcome Robert H. Lurie Comprehensive Cancer Center',
            button: 'Let’s Get Started',
            bottomText: 'No Credit Card Required',
            successMessage: '',
            errorMessage: 'Invalid email address or password'
        },
        ADR: {
            title: 'Mindfulness matters',
            message: 'Welcome Always Discovering & Recovering (ADR) Foundation',
            button: 'Let’s Get Started',
            bottomText: 'No Credit Card Required',
            successMessage: '',
            errorMessage: 'Invalid email address or password'
        },
        registrationRMHC: {
            title: 'Mindfulness matters',
            message: 'Welcome RMHC® families',
            button: 'Let’s Get Started',
            bottomText: 'No Credit Card Required',
            successMessage: '',
            errorMessage: 'Invalid email address or password'
        },
        registrationActiveMinds: {
            message:
                'Active Minds students, welcome to the ' +
                '</br>' +
                'Chill community.'
        },
        registrationRushStaff: {
            message: 'Welcome Rush University Cancer Center Staff'
        },
        registrationRush: {
            message:
                'Welcome Rush University Cancer Center Patients + Caregivers'
        },
        registrationHolidayChill: {
            message: "Happy Holidays. Let's Chill."
        },
        registrationLoyola: {
            message: 'Welcome Loyola University'
        },
        registrationThresholds: {
            message: 'Welcome Thresholds'
        },
        registrationRMHCStaff: {
            message: 'Welcome Chapter Staff'
        },
        registrationByBusiness: {
            title: 'Mindfulness Matters',
            button: 'Let’s Get Started',
            bottomText: 'No Credit Card Required',
            successMessage: '',
            errorMessage: 'Invalid email address or password'
        },
        registrationCorporate: {
            title: 'Sign Up',
            message:
                'Mindfulness matters. And we’re glad to see you agree. Log in. Leave less stressed. It’s good for you.\n' +
                '</br>' +
                '</br>' +
                'Interested in learning more about Chill Anywhere and seeing what a little extra mindfulness can do for you?',
            button: 'SIGN UP',
            successMessage: '',
            errorMessage: 'Invalid email address or password'
        },
        registrationPublic: {
            title: 'Sign Up For A Free Trial',
            message:
                'We believe that small shifts in our daily routine add up to big changes. A little extra mindfulness each day leads to happier employees, increased productivity, and less stress. \n' +
                '</br>' +
                '</br>' +
                'Let us know a little bit about yourself and we will get you all set up for a free one-week trial.',
            button: 'SIGN UP',
            successMessage: '',
            errorMessage: 'Invalid email address or password'
        },
        confirmEmail: {
            title: 'Email confirmation',
            message:
                "You're almost there! Enter the verification code we sent to your email address below. If you can't find it, it might be in your spam folder.",
            messageBottom: '',
            button: 'CONFIRM',
            buttonResend: 'RESEND VERIFICATION CODE',
            successMessage: '',
            errorMessage:
                'Oops! It looks like you might have entered the wrong verification code. Give it another try.'
        },
        login: {
            title: 'Welcome',
            message:
                'Mindfulness matters. \n' +
                '</br>' +
                'And we’re glad to see you agree. \n' +
                '</br>' +
                'Log in. Leave less stressed. It’s good for you.',
            button: 'Login',
            link: 'Reset password',
            signUpNow: 'Sign up now',
            errorMessage: 'Invalid email address or password'
        },
        firstLogin: {
            title: 'Set Your Password',
            message:
                'Let’s turn down the volume on the noise and the rush of everyday life together, shall we? \n</br>All you need to do to get started is to set your password. See ya, stress.',
            button: 'Let’s Get Started',
            successMessage: 'Password has been confirmed',
            errorMessage: 'Invalid email'
        },
        forgotPassword: {
            title: 'Reset',
            message:
                'One of those days? It happens to all of us. \n</br>Please remind us of your email and we’ll immediately send you a note to walk you through a reset.',
            button: 'Reset',
            link: 'Back to Sign in page',
            successMessage: 'Password has been reset'
        },
        description: [
            'Chill Anywhere is only available through your employer or organization.',
            'Need Help? Email'
        ]
    }
};
